import groq from "groq";
import { localisedField } from "../../groq-utils/localisedField";
export const productTagFields = groq`
    _id,
    "label": ${localisedField("label")},
    iconName
`;
